module.exports = __webpack_public_path__ + "13c96d3dfe078e15481f9b458619abcb.pdf";